module.exports = __webpack_public_path__ + "img/silver.cover.d4a1a9ec.png";